import { Table } from 'antd';
import moment from 'moment';
import React from 'react';
import { DAYTIME_FORMAT, DAY_FORMAT, JOB_ORDER_STATUSES } from '../../../constants';
import './JobOrdersTable.scss';
import { ReactSVG } from 'react-svg';
import { formatClientDeliveryWindowOption } from '../../../utils/clientDeliveryWindowLabel';
import { formatCreatedBy } from '../../../utils/createdByLabel';

const JobOrdersTable = ({ withAction, dataSource, selectedRowKeys, onSelectChange, ...props }) => {
  const columns = [
    {
      title: 'Order ID',
      dataIndex: 'orderId',
      key: 'orderId',
      fixed: 'left',
      width: 150,
    },
    {
      title: '',
      key: 'specialDelivery',
      width: 140,
      render: (row) => (row.isSpecialDelivery ? <span className="specialDeliveryBadge">Special Delivery</span> : ''),
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 160,
      render: (value) => {
        return value ? moment(value).format(DAYTIME_FORMAT) : '';
      },
    },
    {
      title: 'Delivery Date',
      dataIndex: 'deliveryDate',
      key: 'deliveryDate',
      width: 150,
      render: (value) => {
        return value ? moment.parseZone(value).format(DAY_FORMAT) : '';
      },
    },
    {
      title: 'Client time option',
      key: 'clientDeliveryWindowOption',
      width: 200,
      render: (row) => formatClientDeliveryWindowOption(row.clientDeliveryWindowOption),
    },
    {
      title: 'Client',
      key: 'Client Name',
      width: 150,
      render: (row) => {
        return row?.user?.name || '';
      },
    },
    {
      title: 'Client Phone',
      key: 'Client Phone',
      width: 150,
      render: (row) => {
        return row?.user?.phone || '';
      },
    },
    {
      title: 'Created By',
      key: 'createdBy',
      width: 180,
      render: (row) => formatCreatedBy(row),
    },
    {
      title: 'Driver',
      key: 'Driver Name',
      width: 150,
      render: (row) => {
        return row?.driver?.user?.firstName
          ? row?.driver?.user?.firstName + ' ' + row?.driver?.user?.lastName
          : row.driver?.user?.name || '';
      },
    },
    {
      title: 'Driver Phone',
      key: 'Driver Phone',
      width: 150,
      render: (row) => {
        return row?.driver?.user?.phone || '';
      },
    },
    {
      title: 'Pickup Contact Name',
      key: 'contactName',
      dataIndex: 'contactName',
      width: 200,
    },
    {
      title: 'Pickup Contact Phone',
      key: 'contactPhone',
      dataIndex: 'contactPhone',
      width: 220,
    },
    {
      title: 'Pickup Address',
      dataIndex: 'pickupAddress',
      key: 'pickupAddress',
    },
    {
      title: 'Delivery Contact Name',
      key: 'deliveryContactName',
      dataIndex: 'deliveryContactName',
      width: 200,
    },
    {
      title: 'Delivery Contact Phone',
      key: 'deliveryContactPhone',
      dataIndex: 'deliveryContactPhone',
      width: 220,
    },
    {
      title: 'Delivery Address',
      dataIndex: 'deliveryAddress',
      key: 'deliveryAddress',
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 160,
      render: (value) => {
        return value ? moment(value).format(DAYTIME_FORMAT) : '';
      },
    },
    {
      title: 'Status',
      width: 150,
      fixed: 'right',
      key: 'status',
      render(row) {
        const status = row.status === 'PENDING' && row.paymentStatus === 'PAID' ? 'PAID' : row.status;
        return <span className={'jobOrderStatus ' + status}>{JOB_ORDER_STATUSES[status]}</span>;
      },
    },
    {
      key: 'star',
      width: 60,
      fixed: 'right',
      render(row) {
        return (
          row.rating && (
            <div className="star-rating">
              <span className="rating-value">{row.rating}</span>
              <ReactSVG className="star-icon" src="/icons/star.svg" />
            </div>
          )
        );
      },
    },
  ];

  if (withAction) {
    columns.push({
      key: 'action',
      width: 120,
      fixed: 'right',
      render(record) {
        return withAction(record);
      },
    });
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <div className="table-job-orders table-common">
      <Table
        columns={columns}
        rowSelection={rowSelection}
        scroll={{ x: 4100 }}
        dataSource={dataSource}
        rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-dark' : 'table-row-light')}
        {...props}
      />
    </div>
  );
};

export default JobOrdersTable;
